import React, { Component } from "react";
import { Typography } from "material-ui";
import PropTypes from "prop-types";
import FirebaseAuthUI from "../components/FirebaseAuthUI";
import { wrapComponent } from "../utils/container";
import { checkApiToken } from "../actions/login.actions";
import queryString from "query-string";

const styleSheet = theme => ({
    container: {
        marginTop: "24px",
        width: "100%",
        margin: "auto",
        textAlign: "center"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    }
});

class LoginPage extends Component {
    state = {
        username: "",
        password: ""
    };

    componentDidMount() {
        this.props.dispatch(checkApiToken());
    }

    render() {
        const { classes, t, location } = this.props;

        const search = queryString.parse(location.search);
        let redirect;
        if (search && search.redirect) {
            redirect = search.redirect;
        }
        return (
            <div className={classes.container}>
                <div>
                    <Typography type="headline" component="h2">
                        {t("loginPage.Sign in")}
                    </Typography>
                </div>
                <FirebaseAuthUI redirect={redirect} />
            </div>
        );
    }
}

LoginPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    firebase: PropTypes.object,
    t: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.firebase.auth,
        firebase: state.firebase
    };
}

export default wrapComponent(LoginPage, styleSheet, mapStateToProps);



// WEBPACK FOOTER //
// ./src/containers/LoginPage.jsx